// removed by extract-text-webpack-plugin
module.exports = {"SquaredCheckBox":"SquaredCheckbox__SquaredCheckBox__1p9pC","SquaredRadioContainer":"SquaredCheckbox__SquaredRadioContainer__2TOeE","SquaredRadio":"SquaredCheckbox__SquaredRadio__1WgDy","RadioSelected":"SquaredCheckbox__RadioSelected__t8p6D","Label":"SquaredCheckbox__Label__3RfkX","Icon":"SquaredCheckbox__Icon__2qhZt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Checkbox/SquaredCheckbox/SquaredCheckbox.css
// module id = 125
// module chunks = 0